@if (authService.hasPermission(Permission.OutputsCollectionsFull)) {
  <button
    mat-menu-item
    (click)="onRelease()"
    [disabled]="selectedProducts.length === 0"
    >
    <mat-icon>send</mat-icon>
    <span>Release Collection</span>
  </button>
}
